import { ApiService } from './api/api'

export default class BusinessUnitsService {
	private apiService

	constructor() {
		this.apiService = new ApiService()
	}

	/**
	 * Get all document types
	 * @returns Promise
	 */
	getAll(): Promise<any> {
		return this.apiService.get(`/business-units`)
	}
}
